import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ICombinedStore } from './store.interface';
import { cartDataSlice } from './cartData';
import { kamFlagDataSlice } from './kameleoonFlags';
import { launchdarklyFlagDataSlice } from './launchdarklyFlags';
import { viewDefinitionSlice } from './viewDefinition';
import { headerFooterSlice } from './headerFooter';

export const useStore = create<ICombinedStore>()(
  devtools(
    (...a) => ({
      ...cartDataSlice(...a),
      ...viewDefinitionSlice(...a),
      ...headerFooterSlice(...a),
      ...kamFlagDataSlice(...a),
      ...launchdarklyFlagDataSlice(...a),
    }),
    {
      name: 'storage',
    }
  )
);
